<template>

    <div class="page">

        <kt-datatable
          :model="techModel"  
          :data="listArray"
        >
          <template #view_actions="scope">
            <kt-dropmenu v-model:visible="actionDropdown['row_' + scope.row.Id]">
              <template #button>
                <button
                    class="btn btn-sm"
                    @click="actionDropdown['row_' + scope.row.Id] = !actionDropdown['row_' + scope.row.Id]"
                >
                  <span><i class="fas fa-ellipsis-v"></i></span>
                </button>
              </template>
              <template #dropmenu>
                <ul class="dropdown-menu show">
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-primary form-control" @click="editRecord(scope.row.Id)">
                        <i class="fa fa-edit"></i> Edit
                      </button>
                    </label>
                  </li>
                  <li>
                    <label class="dropdown-item">
                      <button class="btn btn-sm btn-outline-danger form-control" @click="deleteTech(scope.row.Id)">
                        <i class="fa fa-trash"></i> Delete
                      </button>
                    </label>
                  </li>
                </ul>
              </template>

            </kt-dropmenu>
          </template>

          <template #after-search="scope">
            <div class="btn-group">
          <button @click="refresh()" 
              class="btn btn-sm btn-outline-secondary"
          >Refresh <i class="fa fa-sync"></i></button>

          <button @click="newRecord()" 
              class="btn btn-sm btn-outline-primary"
          >New <i class="fa fa-plus"></i></button>
          </div>
        </template>
          
        </kt-datatable>

        <router-view name="modal"></router-view>
    </div>
    
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from 'vue-router';
import { storeToRefs } from "pinia";
import ApiService from "@/services/ApiService";
import Emitter from "@/services/Emitter";
import Alert from "@/services/Alert";

import KtModal from '@/components/UI/KtModal.vue';
import KtDropmenu from '@/components/UI/KtDropmenu.vue';
import { useTechStore } from '@/stores/TechStore';
import KtDatatable from "@/components/UI/KtDatatable.vue";

const router = useRouter();
const techStore = useTechStore();
const { list } = storeToRefs(techStore);
const unlisten = [];

const actionDropdown = ref({});

// Convert list object to array for datatable
const listArray = computed(() => {
    return Object.values(list.value);
});

const techModel = [
  {
    name: "Actions",
    label: "Actions",
    type: "actions",
  },
  {
    name: "Id",
    display: false
  },
  {
    name: "TechnicianName",
    label: "Name",
    display: true,
  },
  {
    name: "Email",
    label: "Email",
    display: true,
  },
  {
    name: "Active",
    display: true,
    type: "boolean",
  },
  {
    name: "DisplayOnList",
    label: "Display On List",
    display: true,
    type: "boolean",
  },
  {
    name: "SortOrder",
    label: "Sort Order",
    display: false
  }
];

const newRecord = () =>
{
    router.push({
        path: "/tech/edit/new"
    });
};

const editRecord = (id) =>
{
    router.push({
        path: "/tech/edit/" + id
    });
};

const refresh = () =>
{
    techStore.reload();
};

unlisten.push(Emitter.on("refresh", refresh));

const deleteTech = (id) =>
{
    Alert.confirm("Are you sure you want to delete this technician?", async () => {
        try {
            await ApiService.deleteTech(id);
            await techStore.reload();
            Alert.notify({
                text: "Technician deleted successfully",
                type: "success"
            });
        } catch (error) {
            Alert.notify({
                text: "Error deleting technician: " + error.message,
                type: "error"
            });
        }
    });
};

onMounted(async () =>
{
    await techStore.reload();
});

onUnmounted(() =>
{
    unlisten.forEach((unlisten) => unlisten());
});

</script>